import { defineStore } from 'pinia'

function initialState() {
  return {
    contactForm: {},
    searchAreaForm: {
      prefecture: {
        text: null,
        id: null
      },
      area: {
        text: null,
        id: null
      }
    },
    rentalCarForm: {
      pickupArea: {
        text: null,
        id: null
      },
      pickupShop: {
        text: null,
        id: null
      },
      returnArea: {
        text: null,
        id: null
      },
      returnShop: {
        text: null,
        id: null
      },
      pickupTime: null,
      returnTime: null
    },
    restaurantForm: {
      main_time: null,
      sub_time: []
    },
    activeForm: null,
    activeField: null
  }
}

export const useFormStore = defineStore('Form', {
  state: initialState,

  getters: {
    currentActiveForm: (state) => state[state.activeForm]
  },

  actions: {
    setInitialContactForm(initialValues = {}) {
      this.contactForm = initialValues
    },
    setInitialRestaurantForm(initialValues = {}) {
      this.restaurantForm = {
        ...this.restaurantForm,
        ...initialValues
      }
    },
    setFormFieldValue(value) {
      this[this.activeForm][this.activeField] = value
    },
    assignFieldValue(field) {
      this[this.activeForm] = {
        ...this[this.activeForm],
        ...field
      }
    },
    setActiveForm(formName) {
      this.activeForm = formName
    },
    setActiveField(fieldName) {
      this.activeField = fieldName
    },
    resetOtherFormFields(fieldNames) {
      fieldNames.forEach((fieldName) => {
        this.rentalCarForm[fieldName] = initialState().rentalCarForm[fieldName]
      })
    },
    syncPickupReturn() {
      this.rentalCarForm.returnArea = this.rentalCarForm.pickupArea
      this.rentalCarForm.returnShop = this.rentalCarForm.pickupShop
    }
  }
})
